"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackUrl = exports.JoinSlackCommunityUrl = exports.CalendlyUrlForBookACall = exports.CalendlyUrlForExportReview = exports.CalendlyUrlForCancelPlan = exports.JoinSlackCommunityConfig = exports.BookACallWithFluxConfig = void 0;
const zod_1 = require("zod");
exports.BookACallWithFluxConfig = zod_1.z.enum(["off", "on", "control"]);
exports.JoinSlackCommunityConfig = zod_1.z.enum(["off", "on", "control"]);
exports.CalendlyUrlForCancelPlan = "https://calendly.com/build-with-flux/is-flux-right-for-you";
exports.CalendlyUrlForExportReview = "https://calendly.com/build-with-flux/flux-board-review";
exports.CalendlyUrlForBookACall = "https://calendly.com/build-with-flux/flux-onboarding";
exports.JoinSlackCommunityUrl = "https://www.flux.ai/p/slack-community";
exports.FeedbackUrl = "https://fluxai.canny.io/";
//# sourceMappingURL=contact.js.map